// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DevicesHeader-module__font-s-10___rmLVx {
  font-size: 10px !important;
}

.DevicesHeader-module__font-s-12___m2Jsq {
  font-size: 12px !important;
}

.DevicesHeader-module__font-s-13___qUm6h {
  font-size: 13px !important;
}

.DevicesHeader-module__font-s-14___J4NJH {
  font-size: 14px !important;
}

.DevicesHeader-module__font-s-15___B_Edy {
  font-size: 15px !important;
}

.DevicesHeader-module__font-s-16___lP4ur {
  font-size: 16px !important;
}

.DevicesHeader-module__font-s-18___eQGlZ {
  font-size: 18px !important;
}

.DevicesHeader-module__font-s-20___rxg3b {
  font-size: 20px !important;
}

.DevicesHeader-module__font-s-22___DfOK9 {
  font-size: 22px !important;
}

.DevicesHeader-module__font-s-28___dq8t1 {
  font-size: 28px !important;
}

.DevicesHeader-module__font-w-400___YFx8C {
  font-weight: 400 !important;
}

.DevicesHeader-module__font-w-500___aDiV4 {
  font-weight: 500 !important;
}

.DevicesHeader-module__font-w-600___YU2Rl {
  font-weight: 600 !important;
}

.DevicesHeader-module__font-w-700___XEc47 {
  font-weight: 700 !important;
}

.DevicesHeader-module__p-5___M7U8d {
  padding: 5px !important;
}

.DevicesHeader-module__p-12___Ymp9K {
  padding: 12px !important;
}

.DevicesHeader-module__p-16___rG7fc {
  padding: 16px !important;
}

.DevicesHeader-module__p-30___eNviD {
  padding: 30px !important;
}

.DevicesHeader-module__p-b-0___usUAm {
  padding-bottom: 0 !important;
}

.DevicesHeader-module__p-b-5___fRsFx {
  padding-bottom: 5px !important;
}

.DevicesHeader-module__p-b-10___fKXBz {
  padding-bottom: 10px !important;
}

.DevicesHeader-module__p-b-12___jJqGu {
  padding-bottom: 12px !important;
}

.DevicesHeader-module__p-b-16___ZcrVx {
  padding-bottom: 16px !important;
}

.DevicesHeader-module__p-b-18___SRda4 {
  padding-bottom: 18px !important;
}

.DevicesHeader-module__p-b-20___yIqpH {
  padding-bottom: 20px !important;
}

.DevicesHeader-module__p-b-25___uukrM {
  padding-bottom: 25px !important;
}

.DevicesHeader-module__p-b-30___gzJ3t {
  padding-bottom: 30px !important;
}

.DevicesHeader-module__p-b-50___YSXLy {
  padding-bottom: 50px !important;
}

.DevicesHeader-module__p-t-0___nMQzx {
  padding-top: 0 !important;
}

.DevicesHeader-module__p-t-12___wOKUy {
  padding-top: 12px !important;
}

.DevicesHeader-module__p-t-16___zDMuv {
  padding-top: 16px !important;
}

.DevicesHeader-module__p-t-18___pui7b {
  padding-top: 18px !important;
}

.DevicesHeader-module__p-t-20___msl2L {
  padding-top: 20px !important;
}

.DevicesHeader-module__p-t-30___aeBxA {
  padding-top: 30px !important;
}

.DevicesHeader-module__p-t-40___A9Tqk {
  padding-top: 40px !important;
}

.DevicesHeader-module__p-t-50___Z2qF4 {
  padding-top: 50px !important;
}

.DevicesHeader-module__p-l-20____ZbfY {
  padding-left: 20px !important;
}

.DevicesHeader-module__p-l-30___GUR7Q {
  padding-left: 30px !important;
}

.DevicesHeader-module__p-l-40___iG_Hz {
  padding-left: 40px !important;
}

.DevicesHeader-module__p-r-16___j7g6V {
  padding-right: 16px !important;
}

.DevicesHeader-module__p-r-20___glN1i {
  padding-right: 20px !important;
}

.DevicesHeader-module__p-r-30___NUND8 {
  padding-right: 30px !important;
}

.DevicesHeader-module__p-r-50___MV_A1 {
  padding-right: 50px !important;
}

.DevicesHeader-module__p-r-60___M9mw1 {
  padding-right: 60px !important;
}

.DevicesHeader-module__m-b-1___a949I {
  margin-bottom: 1px !important;
}

.DevicesHeader-module__m-b-2___FOIf9 {
  margin-bottom: 2px !important;
}

.DevicesHeader-module__m-b-6___jv9Xp {
  margin-bottom: 6px !important;
}

.DevicesHeader-module__m-b-8___I8ISw {
  margin-bottom: 8px !important;
}

.DevicesHeader-module__m-b-10___yy_pU {
  margin-bottom: 10px !important;
}

.DevicesHeader-module__m-b-14___s9Ob2 {
  margin-bottom: 14px !important;
}

.DevicesHeader-module__m-b-16___GLkHD {
  margin-bottom: 16px !important;
}

.DevicesHeader-module__m-b-20___gf599 {
  margin-bottom: 20px !important;
}

.DevicesHeader-module__m-b-22___kubz8 {
  margin-bottom: 22px !important;
}

.DevicesHeader-module__m-b-24___OeEFB {
  margin-bottom: 24px !important;
}

.DevicesHeader-module__m-b-30___E54F1 {
  margin-bottom: 30px !important;
}

.DevicesHeader-module__m-b-32___QUFqY {
  margin-bottom: 32px !important;
}

.DevicesHeader-module__m-b-40___NhvrR {
  margin-bottom: 40px !important;
}

.DevicesHeader-module__m-t-2___Lv4KI {
  margin-top: 2px !important;
}

.DevicesHeader-module__m-t-3___nHyNH {
  margin-top: 3px !important;
}

.DevicesHeader-module__m-t-4___dBS76 {
  margin-top: 4px !important;
}

.DevicesHeader-module__m-t-5___NoNnH {
  margin-top: 5px !important;
}

.DevicesHeader-module__m-t-8___fU8Pu {
  margin-top: 8px !important;
}

.DevicesHeader-module__m-t-10___ER913 {
  margin-top: 10px !important;
}

.DevicesHeader-module__m-t-15___cvSLQ {
  margin-top: 15px !important;
}

.DevicesHeader-module__m-t-16___0txND {
  margin-top: 16px !important;
}

.DevicesHeader-module__m-t-20___KBo2E {
  margin-top: 20px !important;
}

.DevicesHeader-module__m-t-22___III3f {
  margin-top: 22px !important;
}

.DevicesHeader-module__m-t-30___htfnH {
  margin-top: 30px !important;
}

.DevicesHeader-module__m-t-32___eote5 {
  margin-top: 32px !important;
}

.DevicesHeader-module__m-l-auto___Bp1rK {
  margin-left: auto !important;
}

.DevicesHeader-module__m-l-4___yBzOh {
  margin-left: 4px !important;
}

.DevicesHeader-module__m-l-5___axku5 {
  margin-left: 5px !important;
}

.DevicesHeader-module__m-l-6___fv0C2 {
  margin-left: 6px !important;
}

.DevicesHeader-module__m-l-8___diSPr {
  margin-left: 8px !important;
}

.DevicesHeader-module__m-l-10___x0KoD {
  margin-left: 10px !important;
}

.DevicesHeader-module__m-l-16___OJ52Z {
  margin-left: 16px !important;
}

.DevicesHeader-module__m-l-20___hCb54 {
  margin-left: 20px !important;
}

.DevicesHeader-module__m-l-24___Lb9P3 {
  margin-left: 24px !important;
}

.DevicesHeader-module__m-l-30___kFKwo {
  margin-left: 30px !important;
}

.DevicesHeader-module__m-l-35___bOeOq {
  margin-left: 35px !important;
}

.DevicesHeader-module__m-l-40___kL3mv {
  margin-left: 40px !important;
}

.DevicesHeader-module__m-r-8___axpWK {
  margin-right: 8px !important;
}

.DevicesHeader-module__m-r-10___nd5BS {
  margin-right: 10px !important;
}

.DevicesHeader-module__m-r-16___MRa2Q {
  margin-right: 16px !important;
}

.DevicesHeader-module__m-r-20___fLQfP {
  margin-right: 20px !important;
}

.DevicesHeader-module__m-r-24___yMmBx {
  margin-right: 24px !important;
}

.DevicesHeader-module__m-r-30___OP7xK {
  margin-right: 30px !important;
}

.DevicesHeader-module__m-r-40___Yjflh {
  margin-right: 40px !important;
}

.DevicesHeader-module__border-r-3___R5hsX {
  border-radius: 3px !important;
}

.DevicesHeader-module__border-r-4___bU9vU {
  border-radius: 4px !important;
}

.DevicesHeader-module__border-r-6___Ubalg {
  border-radius: 6px !important;
}

.DevicesHeader-module__border-r-10___jDaks {
  border-radius: 10px !important;
}

.DevicesHeader-module__border-r-12___LwWrQ {
  border-radius: 12px !important;
}

.DevicesHeader-module__border-r-16___yGlqf {
  border-radius: 16px !important;
}

.DevicesHeader-module__border-r-50____6G2k {
  border-radius: 50% !important;
}

.DevicesHeader-module__primary-border___nkk2s {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesHeader-module__primary-border-b___bAabL {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesHeader-module__primary-border-t___wwPVb {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesHeader-module__primary-border-l___eNN0k {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesHeader-module__primary-border-r___hN0RQ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DevicesHeader-module__secondary-border___S5FTr {
  border: 1px solid #637768;
}

.DevicesHeader-module__secondary-border-b___nPdSK {
  border-bottom: 1px solid #637768;
}

.DevicesHeader-module__secondary-border-t___kygZz {
  border-top: 1px solid #637768;
}

.DevicesHeader-module__secondary-border-l___obXrx {
  border-left: 1px solid #637768;
}

.DevicesHeader-module__secondary-border-r___wMvMA {
  border-right: 1px solid #637768;
}

.DevicesHeader-module__gap-0___NCzfb {
  gap: 0 !important;
}

.DevicesHeader-module__gap-2___p6aFE {
  gap: 2px !important;
}

.DevicesHeader-module__gap-4____rZt3 {
  gap: 4px !important;
}

.DevicesHeader-module__gap-5___wwcxe {
  gap: 5px !important;
}

.DevicesHeader-module__gap-6___sCZhI {
  gap: 6px !important;
}

.DevicesHeader-module__gap-8___wU3ry {
  gap: 8px !important;
}

.DevicesHeader-module__gap-10___gmpqa {
  gap: 10px !important;
}

.DevicesHeader-module__gap-12___YReZH {
  gap: 12px !important;
}

.DevicesHeader-module__gap-14___hkbP5 {
  gap: 14px !important;
}

.DevicesHeader-module__gap-16___YNONr {
  gap: 16px !important;
}

.DevicesHeader-module__gap-18___RLwiL {
  gap: 18px !important;
}

.DevicesHeader-module__gap-20___bLOK5 {
  gap: 20px !important;
}

.DevicesHeader-module__gap-24___U0Ysf {
  gap: 24px !important;
}

.DevicesHeader-module__gap-26___fljc2 {
  gap: 26px !important;
}

.DevicesHeader-module__gap-30___Cx2my {
  gap: 30px !important;
}

.DevicesHeader-module__gap-32___kzWb7 {
  gap: 32px !important;
}

.DevicesHeader-module__gap-40___LsOQc {
  gap: 40px !important;
}

.DevicesHeader-module__gap-50___lztkC {
  gap: 50px !important;
}

.DevicesHeader-module__flex-1___CG9PD {
  flex: 1;
}

.DevicesHeader-module__flex-none___NCttf {
  flex: none !important;
}

.DevicesHeader-module__flex-column___iWWON {
  display: flex;
  flex-direction: column !important;
}

.DevicesHeader-module__flex-row___fmnv9 {
  display: flex;
  flex-direction: row !important;
}

.DevicesHeader-module__vertically-centered___mEqI_ {
  display: flex;
  align-items: center !important;
}

.DevicesHeader-module__horizontally-centered___kOe5N {
  display: flex;
  justify-content: center !important;
}

.DevicesHeader-module__horizontally-end___XvJTm {
  display: flex;
  justify-content: end !important;
}

.DevicesHeader-module__vertically-start___CvZAP {
  display: flex;
  align-items: start !important;
}

.DevicesHeader-module__space-between___Gh2Hh {
  display: flex;
  justify-content: space-between !important;
}

.DevicesHeader-module__flex-wrap___y6DnP {
  flex-wrap: wrap !important;
}

.DevicesHeader-module__height-100___QM8Zu {
  height: 100%;
}

.DevicesHeader-module__width-50___tnN2J {
  width: 50% !important;
}

.DevicesHeader-module__width-100___oqahr {
  width: 100%;
}

.DevicesHeader-module__cursor-pointer___ZCg4I {
  cursor: pointer;
}

.DevicesHeader-module__cursor-not-allowed___X0zwB {
  cursor: not-allowed !important;
}

.DevicesHeader-module__absolute-centered___MoQDv {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DevicesHeader-module__absolute___h8uTP {
  position: absolute;
}

.DevicesHeader-module__relative___C0See {
  position: relative;
}

.DevicesHeader-module__fixed___IKTPr {
  position: fixed;
}

.DevicesHeader-module__visible___fXOAP {
  opacity: 1;
}

.DevicesHeader-module__invisible___aunx2 {
  opacity: 0;
}

.DevicesHeader-module__col-90___YZ6Az {
  width: 90% !important;
}

.DevicesHeader-module__col-auto___Y2M_4 {
  width: auto !important;
}

.DevicesHeader-module__medical-tabs___CZGa0 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DevicesHeader-module__medical-table-new___AJDec {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DevicesHeader-module__medical-table-new___AJDec:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DevicesHeader-module__medical-table-new___AJDec::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DevicesHeader-module__medical-table-new___AJDec::-webkit-scrollbar-track {
  display: none;
}
.DevicesHeader-module__medical-table-new___AJDec.DevicesHeader-module__no-pagination___ZHHp4 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DevicesHeader-module__medical-table-new___AJDec.DevicesHeader-module__no-pagination___ZHHp4:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DevicesHeader-module__medical-table-new___AJDec.DevicesHeader-module__no-pagination___ZHHp4::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DevicesHeader-module__medical-table-new___AJDec.DevicesHeader-module__no-pagination___ZHHp4::-webkit-scrollbar-track {
  display: none;
}

.DevicesHeader-module__medical-table-empty___UG7wY {
  padding: 14px 40px !important;
}

.DevicesHeader-module__icon-btn___Dgob2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DevicesHeader-module__search-icon___hOv8T {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DevicesHeader-module__disable-select___zlqQ_ {
  user-select: none;
}

.DevicesHeader-module__break-word___divy7 {
  word-break: break-word;
}

.DevicesHeader-module__popup-clear-btn___eFG0u {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DevicesHeader-module__scroll-m-b-20___WILKQ {
  scroll-margin-bottom: 20px;
}

.DevicesHeader-module__content___PKuag {
  display: flex;
  padding: 30px 40px;
}
.DevicesHeader-module__content___PKuag .DevicesHeader-module__button___nBXTa {
  height: 38px;
  width: 150px;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DevicesFragment/components/DevicesHeader/DevicesHeader.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.content {\n  display: flex;\n  padding: 30px 40px;\n\n  .button {\n    height: 38px;\n    width: 150px;\n    margin-left: auto;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DevicesHeader-module__font-s-10___rmLVx`,
	"fontS12": `DevicesHeader-module__font-s-12___m2Jsq`,
	"fontS13": `DevicesHeader-module__font-s-13___qUm6h`,
	"fontS14": `DevicesHeader-module__font-s-14___J4NJH`,
	"fontS15": `DevicesHeader-module__font-s-15___B_Edy`,
	"fontS16": `DevicesHeader-module__font-s-16___lP4ur`,
	"fontS18": `DevicesHeader-module__font-s-18___eQGlZ`,
	"fontS20": `DevicesHeader-module__font-s-20___rxg3b`,
	"fontS22": `DevicesHeader-module__font-s-22___DfOK9`,
	"fontS28": `DevicesHeader-module__font-s-28___dq8t1`,
	"fontW400": `DevicesHeader-module__font-w-400___YFx8C`,
	"fontW500": `DevicesHeader-module__font-w-500___aDiV4`,
	"fontW600": `DevicesHeader-module__font-w-600___YU2Rl`,
	"fontW700": `DevicesHeader-module__font-w-700___XEc47`,
	"p5": `DevicesHeader-module__p-5___M7U8d`,
	"p12": `DevicesHeader-module__p-12___Ymp9K`,
	"p16": `DevicesHeader-module__p-16___rG7fc`,
	"p30": `DevicesHeader-module__p-30___eNviD`,
	"pB0": `DevicesHeader-module__p-b-0___usUAm`,
	"pB5": `DevicesHeader-module__p-b-5___fRsFx`,
	"pB10": `DevicesHeader-module__p-b-10___fKXBz`,
	"pB12": `DevicesHeader-module__p-b-12___jJqGu`,
	"pB16": `DevicesHeader-module__p-b-16___ZcrVx`,
	"pB18": `DevicesHeader-module__p-b-18___SRda4`,
	"pB20": `DevicesHeader-module__p-b-20___yIqpH`,
	"pB25": `DevicesHeader-module__p-b-25___uukrM`,
	"pB30": `DevicesHeader-module__p-b-30___gzJ3t`,
	"pB50": `DevicesHeader-module__p-b-50___YSXLy`,
	"pT0": `DevicesHeader-module__p-t-0___nMQzx`,
	"pT12": `DevicesHeader-module__p-t-12___wOKUy`,
	"pT16": `DevicesHeader-module__p-t-16___zDMuv`,
	"pT18": `DevicesHeader-module__p-t-18___pui7b`,
	"pT20": `DevicesHeader-module__p-t-20___msl2L`,
	"pT30": `DevicesHeader-module__p-t-30___aeBxA`,
	"pT40": `DevicesHeader-module__p-t-40___A9Tqk`,
	"pT50": `DevicesHeader-module__p-t-50___Z2qF4`,
	"pL20": `DevicesHeader-module__p-l-20____ZbfY`,
	"pL30": `DevicesHeader-module__p-l-30___GUR7Q`,
	"pL40": `DevicesHeader-module__p-l-40___iG_Hz`,
	"pR16": `DevicesHeader-module__p-r-16___j7g6V`,
	"pR20": `DevicesHeader-module__p-r-20___glN1i`,
	"pR30": `DevicesHeader-module__p-r-30___NUND8`,
	"pR50": `DevicesHeader-module__p-r-50___MV_A1`,
	"pR60": `DevicesHeader-module__p-r-60___M9mw1`,
	"mB1": `DevicesHeader-module__m-b-1___a949I`,
	"mB2": `DevicesHeader-module__m-b-2___FOIf9`,
	"mB6": `DevicesHeader-module__m-b-6___jv9Xp`,
	"mB8": `DevicesHeader-module__m-b-8___I8ISw`,
	"mB10": `DevicesHeader-module__m-b-10___yy_pU`,
	"mB14": `DevicesHeader-module__m-b-14___s9Ob2`,
	"mB16": `DevicesHeader-module__m-b-16___GLkHD`,
	"mB20": `DevicesHeader-module__m-b-20___gf599`,
	"mB22": `DevicesHeader-module__m-b-22___kubz8`,
	"mB24": `DevicesHeader-module__m-b-24___OeEFB`,
	"mB30": `DevicesHeader-module__m-b-30___E54F1`,
	"mB32": `DevicesHeader-module__m-b-32___QUFqY`,
	"mB40": `DevicesHeader-module__m-b-40___NhvrR`,
	"mT2": `DevicesHeader-module__m-t-2___Lv4KI`,
	"mT3": `DevicesHeader-module__m-t-3___nHyNH`,
	"mT4": `DevicesHeader-module__m-t-4___dBS76`,
	"mT5": `DevicesHeader-module__m-t-5___NoNnH`,
	"mT8": `DevicesHeader-module__m-t-8___fU8Pu`,
	"mT10": `DevicesHeader-module__m-t-10___ER913`,
	"mT15": `DevicesHeader-module__m-t-15___cvSLQ`,
	"mT16": `DevicesHeader-module__m-t-16___0txND`,
	"mT20": `DevicesHeader-module__m-t-20___KBo2E`,
	"mT22": `DevicesHeader-module__m-t-22___III3f`,
	"mT30": `DevicesHeader-module__m-t-30___htfnH`,
	"mT32": `DevicesHeader-module__m-t-32___eote5`,
	"mLAuto": `DevicesHeader-module__m-l-auto___Bp1rK`,
	"mL4": `DevicesHeader-module__m-l-4___yBzOh`,
	"mL5": `DevicesHeader-module__m-l-5___axku5`,
	"mL6": `DevicesHeader-module__m-l-6___fv0C2`,
	"mL8": `DevicesHeader-module__m-l-8___diSPr`,
	"mL10": `DevicesHeader-module__m-l-10___x0KoD`,
	"mL16": `DevicesHeader-module__m-l-16___OJ52Z`,
	"mL20": `DevicesHeader-module__m-l-20___hCb54`,
	"mL24": `DevicesHeader-module__m-l-24___Lb9P3`,
	"mL30": `DevicesHeader-module__m-l-30___kFKwo`,
	"mL35": `DevicesHeader-module__m-l-35___bOeOq`,
	"mL40": `DevicesHeader-module__m-l-40___kL3mv`,
	"mR8": `DevicesHeader-module__m-r-8___axpWK`,
	"mR10": `DevicesHeader-module__m-r-10___nd5BS`,
	"mR16": `DevicesHeader-module__m-r-16___MRa2Q`,
	"mR20": `DevicesHeader-module__m-r-20___fLQfP`,
	"mR24": `DevicesHeader-module__m-r-24___yMmBx`,
	"mR30": `DevicesHeader-module__m-r-30___OP7xK`,
	"mR40": `DevicesHeader-module__m-r-40___Yjflh`,
	"borderR3": `DevicesHeader-module__border-r-3___R5hsX`,
	"borderR4": `DevicesHeader-module__border-r-4___bU9vU`,
	"borderR6": `DevicesHeader-module__border-r-6___Ubalg`,
	"borderR10": `DevicesHeader-module__border-r-10___jDaks`,
	"borderR12": `DevicesHeader-module__border-r-12___LwWrQ`,
	"borderR16": `DevicesHeader-module__border-r-16___yGlqf`,
	"borderR50": `DevicesHeader-module__border-r-50____6G2k`,
	"primaryBorder": `DevicesHeader-module__primary-border___nkk2s`,
	"primaryBorderB": `DevicesHeader-module__primary-border-b___bAabL`,
	"primaryBorderT": `DevicesHeader-module__primary-border-t___wwPVb`,
	"primaryBorderL": `DevicesHeader-module__primary-border-l___eNN0k`,
	"primaryBorderR": `DevicesHeader-module__primary-border-r___hN0RQ`,
	"secondaryBorder": `DevicesHeader-module__secondary-border___S5FTr`,
	"secondaryBorderB": `DevicesHeader-module__secondary-border-b___nPdSK`,
	"secondaryBorderT": `DevicesHeader-module__secondary-border-t___kygZz`,
	"secondaryBorderL": `DevicesHeader-module__secondary-border-l___obXrx`,
	"secondaryBorderR": `DevicesHeader-module__secondary-border-r___wMvMA`,
	"gap0": `DevicesHeader-module__gap-0___NCzfb`,
	"gap2": `DevicesHeader-module__gap-2___p6aFE`,
	"gap4": `DevicesHeader-module__gap-4____rZt3`,
	"gap5": `DevicesHeader-module__gap-5___wwcxe`,
	"gap6": `DevicesHeader-module__gap-6___sCZhI`,
	"gap8": `DevicesHeader-module__gap-8___wU3ry`,
	"gap10": `DevicesHeader-module__gap-10___gmpqa`,
	"gap12": `DevicesHeader-module__gap-12___YReZH`,
	"gap14": `DevicesHeader-module__gap-14___hkbP5`,
	"gap16": `DevicesHeader-module__gap-16___YNONr`,
	"gap18": `DevicesHeader-module__gap-18___RLwiL`,
	"gap20": `DevicesHeader-module__gap-20___bLOK5`,
	"gap24": `DevicesHeader-module__gap-24___U0Ysf`,
	"gap26": `DevicesHeader-module__gap-26___fljc2`,
	"gap30": `DevicesHeader-module__gap-30___Cx2my`,
	"gap32": `DevicesHeader-module__gap-32___kzWb7`,
	"gap40": `DevicesHeader-module__gap-40___LsOQc`,
	"gap50": `DevicesHeader-module__gap-50___lztkC`,
	"flex1": `DevicesHeader-module__flex-1___CG9PD`,
	"flexNone": `DevicesHeader-module__flex-none___NCttf`,
	"flexColumn": `DevicesHeader-module__flex-column___iWWON`,
	"flexRow": `DevicesHeader-module__flex-row___fmnv9`,
	"verticallyCentered": `DevicesHeader-module__vertically-centered___mEqI_`,
	"horizontallyCentered": `DevicesHeader-module__horizontally-centered___kOe5N`,
	"horizontallyEnd": `DevicesHeader-module__horizontally-end___XvJTm`,
	"verticallyStart": `DevicesHeader-module__vertically-start___CvZAP`,
	"spaceBetween": `DevicesHeader-module__space-between___Gh2Hh`,
	"flexWrap": `DevicesHeader-module__flex-wrap___y6DnP`,
	"height100": `DevicesHeader-module__height-100___QM8Zu`,
	"width50": `DevicesHeader-module__width-50___tnN2J`,
	"width100": `DevicesHeader-module__width-100___oqahr`,
	"cursorPointer": `DevicesHeader-module__cursor-pointer___ZCg4I`,
	"cursorNotAllowed": `DevicesHeader-module__cursor-not-allowed___X0zwB`,
	"absoluteCentered": `DevicesHeader-module__absolute-centered___MoQDv`,
	"absolute": `DevicesHeader-module__absolute___h8uTP`,
	"relative": `DevicesHeader-module__relative___C0See`,
	"fixed": `DevicesHeader-module__fixed___IKTPr`,
	"visible": `DevicesHeader-module__visible___fXOAP`,
	"invisible": `DevicesHeader-module__invisible___aunx2`,
	"col90": `DevicesHeader-module__col-90___YZ6Az`,
	"colAuto": `DevicesHeader-module__col-auto___Y2M_4`,
	"medicalTabs": `DevicesHeader-module__medical-tabs___CZGa0`,
	"medicalTableNew": `DevicesHeader-module__medical-table-new___AJDec`,
	"noPagination": `DevicesHeader-module__no-pagination___ZHHp4`,
	"medicalTableEmpty": `DevicesHeader-module__medical-table-empty___UG7wY`,
	"iconBtn": `DevicesHeader-module__icon-btn___Dgob2`,
	"searchIcon": `DevicesHeader-module__search-icon___hOv8T`,
	"disableSelect": `DevicesHeader-module__disable-select___zlqQ_`,
	"breakWord": `DevicesHeader-module__break-word___divy7`,
	"popupClearBtn": `DevicesHeader-module__popup-clear-btn___eFG0u`,
	"scrollMB20": `DevicesHeader-module__scroll-m-b-20___WILKQ`,
	"content": `DevicesHeader-module__content___PKuag`,
	"button": `DevicesHeader-module__button___nBXTa`
};
module.exports = ___CSS_LOADER_EXPORT___;
